import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-b from-[#111116] to-[#141418] py-10 md:py-16 px-4" data-id="element-256">
      <div className="max-w-3xl mx-auto" data-id="element-257">
        <div className="bg-[#1a1a22] p-6 md:p-12 rounded-2xl border-l-4 border-[#e53935] shadow-lg" data-id="element-258">
          <p className="text-xs md:text-sm text-[#ef5350] font-black tracking-widest uppercase mb-3" data-id="element-259">
            El sistema
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-6 leading-tight text-center md:text-left" data-id="element-260">
            Qué es Método Barber Pro
          </h2>
          <div className="w-12 h-0.5 bg-gradient-to-r from-[#e53935] to-[#ff7043] mb-6 mx-auto md:mx-0" data-id="element-261"></div>

          <div className="space-y-5" data-id="element-262">
            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-263">
              Método Barber Pro es una formación online diseñada para aprender
              barbería con un sistema claro y profesional.
            </p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-264">
              Incluye clases en video, explicación técnica y un manual completo
              que refuerza cada etapa del aprendizaje.
            </p>
            <div className="bg-[#e53935]/10 border border-[#e53935]/30 p-4 rounded-xl mt-6 inline-block" data-id="element-265">
              <p className="text-lg md:text-xl text-white font-black" data-id="element-266">
                No es contenido aislado.{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ef5350] to-[#ff7043]" data-id="element-267">
                  Es un método.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}